import script from "./EventDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EventDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./EventDetailPage.vue?vue&type=style&index=0&id=27021417&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27021417"]])

export default __exports__